var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",class:{
      major: _vm.major,
      minor: !_vm.major,
    }},[(_vm.icon)?_c('span',{staticClass:"icon",class:{ 'coloured-icon': _vm.iconColour !== null },style:(("--icon-colour: " + _vm.iconColour + ";"))},[_c('FontAwesomeIcon',{attrs:{"icon":_vm.icon}})],1):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }